module.exports = __webpack_public_path__ + "static/mobile-mast-6e4e75949cd27df10c877e57bfa49351.png";